<template>
    <list/>
</template>

<script>
import List from '@/domain/components/generalPanel/adminPanel/installation/List';
import GlobalUserService from '@/services/user';

export default {
  components: {
    List,
  },
  created() {
    GlobalUserService.validateUserPermission('PER020');
  },
};
</script>
